import React, { ReactNode } from 'react'

import { RoleTone } from '../../constants'
import Button from '../button/Button'

import {
  BannerContent,
  BannerEyebrow,
  BannerLayout,
  BannerVisual,
} from './styles'

interface EditorialBannerProps {
  title: string
  description: string
  eyebrow: string
  actionLabel: string
  onAction: () => void
  eyebrowIcon?: ReactNode
  actionIcon?: ReactNode
  visual: ReactNode
  tone?: RoleTone
}

const EditorialBanner = ({
  actionIcon,
  actionLabel,
  description,
  eyebrow,
  eyebrowIcon,
  onAction,
  title,
  tone = 'student',
  visual,
}: EditorialBannerProps) => {
  const titleId = React.useId()

  return (
    <BannerLayout aria-labelledby={titleId}>
      <BannerContent>
        <BannerEyebrow $tone={tone}>
          {eyebrowIcon}
          {eyebrow}
        </BannerEyebrow>
        <h2 id={titleId}>{title}</h2>
        <p>{description}</p>
        <Button
          tone={tone}
          icon={actionIcon}
          aria-label={actionLabel}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      </BannerContent>
      <BannerVisual $tone={tone}>{visual}</BannerVisual>
    </BannerLayout>
  )
}

export default EditorialBanner
